import React, { ReactNode } from "react";
import { useAuthentication } from "@/contexts/AuthenticationContext";
import AuthenticatedOnly from "@/user/AuthenticatedOnly";
interface StaffOnlyProps {
    children: React.ReactNode;
}
const StaffOnly: React.FC<StaffOnlyProps> = ({ children }) => {
    const { user } = useAuthentication();
    return user?.is_staff ? <>{children}</> : null;
};

const AuthenticatedAndStaffOnly = ({ children } : { children: ReactNode}) => (
  <AuthenticatedOnly>
      <StaffOnly>
          {children}
      </StaffOnly>
  </AuthenticatedOnly>
)

export default AuthenticatedAndStaffOnly;